<style>
    .searchFilter .dropdown-menu .category_filters li {
        list-style-type: none;
        padding: 2px 10px;
        font-size: 18px;
    }
    .searchFilter .dropdown-menu .category_filters label {
        margin-left: 15px;
    }

    option {
        text-transform: uppercase!important;
    }
</style>
<template>
    <div class="row">
        <div class="col-md-5" style="margin-bottom: 10px!important;">
            <div class="input-group">
                <span class="input-group-btn">
                    <button type="button" class="btn btn-default btn-sm dropdown-toggle" data-toggle="dropdown" style="height: 35px;">
                        <span v-bind:id="columSearch">Coluna </span>
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu campos_filtro_tabela" v-bind:class="classFilterColumn">
                        <li v-for="item in fields" v-if="item.prefix">
                            <a href="#" class="small" v-bind:data-name="item.title" v-bind:data-type="(item.type) ? item.type : 'text'" v-bind:data-value="item.prefix" tabIndex="-1">
                                <input type="radio" name="filter" v-bind:class="namefilter"/> {{ item.title }}
                            </a>
                        </li>
                    </ul>
                </span>
                <select @keyup.enter="doFilter" v-model="filterText" class="form-control" v-if="typeFilter == 'boolean'">
                    <option :value="true" selected>Sim</option>
                    <option :value="false">Não</option>
                </select>
                <select @keyup.enter="doFilter" v-model="filterText" class="form-control" v-else-if="typeFilter == 'select'">
                    <option v-for="f in selectFilter" :value="f.id">{{ f.nome }}</option>
                </select>
                <input type="text" class="form-control" placeholder="Filtrar informações..." @keyup.enter="doFilter" v-model="filterText" style="height: 35px!important;" v-else>
                <span class="input-group-btn">
                    <button class="btn btn-success" style="height: 35px!important;"  type="button" @click="doFilter"><i class="fa fa-filter"></i></button>
                    <button class="btn btn-primary" style="height: 35px" type="button" @click="resetFilter"><i class="fa fa-eraser"></i></button>
                </span>
            </div>
        </div>
        <div class="col-md-6"></div>
        <div class="col-md-1" align="right" v-if="this.selectRow == true">
            <select class="form-control" v-model="perPages" id="perPages" style="width: 80px!important;">
                <option value=10>10</option>
                <option value=15>15</option>
                <option value=20>20</option>
                <option value=25>25</option>
                <option value=50>50</option>
                <option value=100>100</option>
                <option value=250>250</option>
            </select>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue'

    export default {

        props: {
            fields: {
                type: Array,
                required: false,
                default: []
            },
            filtroSelect: {
                type: Array,
                required: false,
                default: []
            },
            classFilterColumn: {
                type: String,
                default: []
            },
            perPage: {
                default: 10
            },
            selectRow: {
                type: Boolean,
                default: false
            }
        },

        data () {
            return {
                optionsFilter: [],
                selectFilter: this.filtroSelect,
                moreParams: {},
                filterText: '',
                typeFilter: 'text',
                namefilter: 'input' + this.classFilterColumn,
                columSearch: 'columSearch' + this.classFilterColumn,
                perPages: this.perPage
            }
        },

        methods: {

            doFilter () {

                var search = [];
                var $this = this;

                search.filtertext = this.filterText;
                search.optionfilter = this.optionsFilter;

                this.$events.fire('filter-set-' +  $this.classFilterColumn, search)

            },

            resetFilter () {

                var $this = this;
                this.filterText = ''
                this.$events.fire('filter-reset-' + $this.classFilterColumn)
            },

            optionFilter: function () {

                var options = [];
                var optionsLabel = [];
                var $this = this;

                var coluna = '.' + $this.classFilterColumn + ' a';

                var nomeInput = '.' + $this.namefilter;
                $( coluna ).on( 'click', function( event ) {

                    var $target = $( event.currentTarget ),
                        val = $target.attr( 'data-value' ),
                        name = $target.attr( 'data-name' ),
                        tipo = $target.attr( 'data-type' ),
                        $inp = $target.find( nomeInput ),
                        idx;

                    if ( ( idx = options.indexOf( val ) ) > -1 ) {
                        optionsLabel.splice( idx, 1 );
                        options.splice( idx, 1 );
                        setTimeout( function() { $inp.prop( 'checked', false ) }, 0);
                    } else {
                        optionsLabel = [];
                        options = [];
                        optionsLabel.push( name );
                        options.push( val );
                        setTimeout( function() { $inp.prop( 'checked', true ) }, 0);
                    }

                    $this.typeFilter = tipo;

                    if(tipo == 'boolean') {

                        $this.filterText = true;
                    } else {

                        $this.filterText = '';
                    }

                    $( event.target ).blur();

                    var o = 0;

                    var campos_pesquisa = '';

                    var coluna_search = '#' + $this.columSearch;

                    $(coluna_search).empty();

                    for(o = 0; o < optionsLabel.length; o ++) {

                        campos_pesquisa += optionsLabel[o];

                    }

                    if(campos_pesquisa == '') {
                        campos_pesquisa = 'Coluna:'
                    }

                    $this.optionsFilter = options;

                    $(coluna_search).append(campos_pesquisa);

                    return false;
                });

            }
        },

        watch: {
            'perPages': function (val, oldVal) {

                var $this = this;
                var search = [];

                search.val = val;
                search.filtertext = this.filterText;
                search.optionfilter = this.optionsFilter;

                this.$events.fire('per-page-' +  $this.classFilterColumn, search);

            }
        },

        mounted () {
//            var $this = this;
//
//            $('#perPages').select2().change(function () {
//
//                var val = $('#perPages').val();
//
//                $this.$events.fire('per-page-' +  $this.classFilterColumn, val);
//
//            });

            this.optionFilter();
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/tables/Filter.vue